import axios from "axios";
import Config from "./config";

export default axios.create({
  baseURL: Config.baseUrl + "/v" + Config.version + "/"

});



// WEBPACK FOOTER //
// ./src/libraries/http.js